<template>
  <v-card elevation="3" color="#FFFFFF">
    <v-card-title class="text"
      >{{ question.literalNumber }} {{ question.question }}</v-card-title
    >

    <!-- question response-->
    <v-card-text>
      <v-radio-group
        v-for="(option, o) in question.options.split(';')"
        :key="o"
        :disabled="disabled"
        v-model="answerVal"
      >
        <v-row align="center" style="margin-left: 1%">
          <v-radio
            :label="option"
            :value="option"
            @click="
              displayOther(false),
                registerAnswer(questionNumber, option),
                displayText(option, o)
            "
          ></v-radio>
          <v-text-field
            v-show="showTxt(o, option)"
            v-model="text[option]"
            label="respuesta"
            style="margin-left: 5px"
            :disabled="disabled"
            v-if="numericOption[option]"
            type="number"
            @keyup="addOptionText(questionNumber, $event, question, option)"
          ></v-text-field>
          <v-text-field
            v-show="showTxt(o, option)"
            v-model="text[option]"
            label="respuesta"
            v-else
            style="margin-left: 5px"
            :disabled="disabled"
            @keyup="addOptionText(questionNumber, $event, question, option)"
          ></v-text-field>
        </v-row>
      </v-radio-group>
      <!-- <v-radio-group v-model="answerVal" style="margin-left: 5px">
        <v-radio label="otro" :disabled="disabled" value="otro" @click="displayOther(true)">{{
          "otro"
        }}</v-radio>
        <v-text-field
          label="otro"
          id="txtOther"
          :disabled="disabled"
          v-on:keyup="addOther(questionNumber, $event, question.question)"
          v-show="show"
        ></v-text-field>
      </v-radio-group> -->
    </v-card-text>
    <evidence-vue
      v-if="question.evidence"
      v-on:addEvidence="addEvidence"
      v-on:addEvidenceDroped="addEvidenceDroped"
    />
  </v-card>
</template>

<script>
import evidenceVue from "@/components/fileUpload.vue";
export default {
  data() {
    return {
      show: false,
      hints: [],
      hover: [],
      showText: [],
      numericOption: [],
      text: [],
      group1: 1,
      answerVal: "",
      numeric: false,
      prevOption: "",
    };
  },
  props: {
    question: Object,
    questionNumber: String,
    answer: String,
    disabled: Boolean,
  },
  methods: {
    displayOther(value) {
      this.show = value;
    },
    showTxt(o, option) {
      return this.showText[o] || this.text[option] != undefined;
    },
    displayText(value, option) {
      if (value.toUpperCase().includes("ESPECIFIQUE")) {
        if (this.showText[option] || this.text[value] != undefined) {
          this.showText[option] = false;
          this.text[value] = undefined;
          return;
        }
        this.showText[option] = true;
      }
      if (
        value.toUpperCase().includes("AÑO") &&
        !value.includes(
          "División territorial propia de la institución, especifique año"
        )
      ) {
        this.numericOption[value] = true;
      }
    },
    addOther(number, answer, question) {
      this.$emit("addOther", {
        number: number,
        answer: answer,
        question: question,
      });
    },
    addOptionText(number, answer, question, option) {
      this.$emit("addOptionText", {
        number: number,
        answer: answer,
        question: question,
        option: option,
      });
    },
    registerAnswer(number, answer) {
      if (this.prevOption == answer) {
        this.text[answer] = "";
        this.answerVal = "";
        answer = "";
      }

      this.$emit("selectAnswer", { number: number, answer: answer });
      this.prevOption = answer;
    },
    addEvidence({ number, file }) {
      this.$emit("addEvidence", { number: number, file: file });
    },
    addEvidenceDroped({ number, file }) {
      this.$emit("addEvidenceDroped", { number: number, file: file });
    },
  },
  components: {
    evidenceVue,
  },
  mounted() {
    this.answerVal = this.answer;
    if (this.answerVal != null) {
      let temp = this.answerVal;
      this.answerVal = temp.split(":")[0];
      this.prevOption = this.answerVal;
      if (temp.split(":").length > 1) {
        this.text[this.answerVal] = temp.split(":")[1];
      }
    }
  },
};
</script>
<style scoped>
.text {
  word-break: normal;
}
</style>